import { createReducer, on } from '@ngrx/store';
import {
  getTableAcl,
  saveTableAcl,
  deleteTableAcl,
  newAclCreated,
  updateAclBatch,
  newUpdatedAclRecords,
  deletedAcl,
  getErrorMessage,
  updateTableAclRecords,
  setUpdatedRecordsNull,
  newlyCreatedAclBatch
} from '../actions/tableacl.actions';

export interface TableAclState {
  tableAclRecords: any;
  data: any;
  tableAcl: any;
}

export const initialState: TableAclState = {
  data: {},
  tableAcl: [],
  tableAclRecords: []
};

export const tableAclReducer = createReducer(
  initialState,
  on(getTableAcl, (state, { apiConstants, tableid }) => ({
    ...state,
    loader: false,
    ...apiConstants,
    ...tableid
  })),
  on(saveTableAcl, (state) => ({
    ...state,
    createdAcl: {},
    loader: true
  })),
  on(deleteTableAcl, (state, { ids }) => ({
    ...state,
    loader: true,
    ...ids
  })),
  on(deletedAcl, (state, { deletedSid }) => {
    let allData: any[] = [];
    if (deletedSid) {
      const toBeFilteredData = [...state.tableAclRecords];
      allData = toBeFilteredData;
      const updateIndex = toBeFilteredData.findIndex((app) => app.sid === deletedSid.ids);
      if (updateIndex !== -1) {
        allData.splice(updateIndex, 1);
      }
    } else {
      allData = [...state.tableAclRecords];
    }
    return {
      ...state,
      ...{ deletedSid },
      tableAclRecords: allData,
      loader: false
    };
  }),
  on(newAclCreated, (state, { createdAcl }) => {
    let allData: any[] = [];
    if (createdAcl) {
      const toBeFilteredData = [...state.tableAclRecords];
      allData = toBeFilteredData;
      const updateIndex = toBeFilteredData.findIndex((app) => app.sid === createdAcl.sid);
      if (updateIndex === -1) {
        allData = [...allData, createdAcl];
      } else {
        allData[updateIndex] = createdAcl;
      }
    } else {
      allData = [...state.tableAclRecords];
    }
    return {
      ...state,
      loader: !createdAcl,
      ...{ createdAcl },
      tableAclRecords: allData
    };
  }),
  on(updateAclBatch, (state, { actionIds }) => ({
    ...state,
    loader: true,
    ...actionIds
  })),
  on(newUpdatedAclRecords, (state, { updatedRecords }) => {
    let allData: any[] = [];
    if (updatedRecords) {
      const toBeFilteredData = [...state.tableAclRecords];
      allData = toBeFilteredData;
      updatedRecords.forEach((acl) => {
        const updateIndex = toBeFilteredData.findIndex((app) => app.sid === acl.sid);
        if (updateIndex > -1) {
          allData[updateIndex] = acl;
        }
      });
    } else {
      allData = [...state.tableAclRecords];
    }
    return {
      ...state,
      loader: false,
      ...{ updatedRecords },
      tableAclRecords: allData
    };
  }),
  on(getErrorMessage, (state, errorMessage) => {
    return {
      ...state,
      errorMessage,
      loader: false
    };
  }),
  on(updateTableAclRecords, (state, { tableAclRecords }) => {
    return {
      ...state,
      tableAclRecords: tableAclRecords,
      loader: false
    };
  }),
  on(setUpdatedRecordsNull, (state, { updatedRecords }) => {
    return {
      ...state,
      ...{ updatedRecords }
    };
  }),
  on(newlyCreatedAclBatch, (state, { newlyCreatedaclDataBatch }) => {
    let allData: any[] = [];
    if (newlyCreatedaclDataBatch) {
      const toBeFilteredData = [...state.tableAclRecords];
      allData = toBeFilteredData;
      newlyCreatedaclDataBatch.forEach((acl) => {
        allData = [...allData, acl];
      });
    } else {
      allData = [...state.tableAclRecords];
    }
    return {
      ...state,
      loader: !newlyCreatedaclDataBatch,
      ...{ newlyCreatedaclDataBatch },
      tableAclRecords: allData
    };
  })
);
